/**
 * Ziyaretin bir push bildiriminden gelip gelmediğini taşır.
 *
 * Bildirim adresine eklenen `pu_id` ve `pu_vid` parametreleri yalnızca ilk
 * yüklemede URL'de bulunur. SPA içi gezinme query string'i düşürdüğü için değerler
 * sekme oturumuna (sessionStorage) yazılır; böylece kullanıcı sayfalar arasında
 * dolaşsa da atıf kaybolmaz.
 *
 * sessionStorage bilinçli tercih: atıf sekme oturumuyla sınırlıdır. localStorage
 * kullanılsaydı haftalar önceki bir bildirim, bugünkü organik ziyareti kendine
 * mal ederdi.
 */

const NOTIFICATION_KEY = "Pushification_NotificationId";
const VISITOR_KEY = "Pushification_PushVisitorId";

export interface PushAttribution {
  notificationId: string | null;
  visitorId: string | null;
}

const read = (key: string): string | null => {
  try {
    const value = sessionStorage.getItem(key);
    return value && value.trim() ? value : null;
  } catch {
    return null;
  }
};

const write = (key: string, value: string): void => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Gizli modda sessionStorage yazılamayabilir; atıf o oturumda kaybolur.
  }
};

/**
 * URL'deki atıf parametrelerini sekme oturumuna alır. Sayfa açılışında bir kez
 * çağrılmalıdır; parametre yoksa daha önce yakalanan değer korunur.
 */
export function capturePushAttribution(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const notificationId = params.get("pu_id");
    const visitorId = params.get("pu_vid");

    if (notificationId) write(NOTIFICATION_KEY, notificationId);
    if (visitorId) write(VISITOR_KEY, visitorId);
  } catch {
    // URL ayrıştırılamazsa atıf yok sayılır.
  }
}

export function getPushAttribution(): PushAttribution {
  return {
    notificationId: read(NOTIFICATION_KEY),
    visitorId: read(VISITOR_KEY),
  };
}

export function isFromPush(): boolean {
  const { notificationId, visitorId } = getPushAttribution();
  return Boolean(notificationId || visitorId);
}
